import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.3566 3.30238C10.0441 3.29626 9.77107 3.5127 9.70576 3.81843L7.42519 14.4929L6.20845 15.7097L8.90974 18.411L10.4369 16.8838C10.7951 16.5256 10.9964 16.0397 10.9964 15.5331L10.9964 3.95476C10.9964 3.59937 10.712 3.30933 10.3566 3.30238ZM7.74989 3.40057C8.01542 2.15776 9.12513 1.2779 10.3957 1.30276C11.0026 1.31463 11.5585 1.52959 11.9992 1.88202C12.4399 1.52959 12.9958 1.31463 13.6026 1.30276C14.8733 1.2779 15.983 2.15776 16.2485 3.40057L18.4055 13.4968L22.6761 17.7674L17.1464 23.2971L12.1473 18.298C12.0963 18.2471 12.047 18.1949 11.9992 18.1416C11.9514 18.1949 11.902 18.2471 11.8511 18.298L6.85199 23.2971L1.32227 17.7674L5.59287 13.4968L7.74989 3.40057ZM14.2926 3.81843C14.2273 3.5127 13.9543 3.29626 13.6418 3.30238C13.2864 3.30933 13.002 3.59937 13.002 3.95476L13.002 15.5331C13.002 16.0397 13.2033 16.5256 13.5615 16.8838L15.0886 18.411L17.7899 15.7097L16.5732 14.4929L14.2926 3.81843Z"}}]};

const GesturePrayFilled = Vue.extend<IconProps>({
  name: 'GesturePrayFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-pray-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GesturePrayFilled;
